import { FileText } from "lucide-react";
import type { Answer } from "@/components/types";
import AnswerSectionRenderer from "./AnswerSectionRenderer";
import FeedbackButtons from "./FeedbackButtons";

interface AssistantAnswerProps {
  answer: Answer;
  onDocumentClick: (documentId: string) => void;
  userQuestion: string;
}

const AssistantAnswer = ({ answer, userQuestion, onDocumentClick }: AssistantAnswerProps) => {
  if (!answer || !answer.sections || !Array.isArray(answer.sections)) {
    return (
      <div className="text-center py-12 text-slate-500">
        <div className="space-y-4">
          <div className="w-16 h-16 mx-auto bg-slate-100 rounded-full flex items-center justify-center">
            <FileText className="w-8 h-8 text-slate-400" />
          </div>
          <div>
            <h3 className="text-lg font-medium text-slate-700 mb-2">אין תוכן תשובה זמין</h3>
            <p className="text-sm">התשובה לא מכילה קטעים זמינים או שיש בעיה בטעינת הנתונים</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {answer.sections.map((section, index) => (
        <AnswerSectionRenderer key={`${section.type}-${index}`} section={section} onDocumentClick={onDocumentClick} />
      ))}
      <FeedbackButtons answer={answer} userQuestion={userQuestion} />
    </div>
  );
};

export default AssistantAnswer;
